"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _scrollAnchor = _interopRequireDefault(require("./scroll-anchor"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
/**
 * Local Imports
 */

const List = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "List",
  class: "pl-l1saakax"
});

/**
 * LinkItem Component.
 *
 * @param {Object} props React props
 * @param {Boolean} props.active Active Condition
 * @returns {React.ReactElement} LinkItem Component
 * @public
 */

function LinkItem({
  active,
  ...rest
}) {
  // TODO: CMS-30048: Clean up this logic to only support the provided target being a react node
  const {
    target: targetNode,
    targetId,
    anchorText
  } = rest;
  const entryId = targetNode?.props?.entryId;
  let target;
  if ((0, _patternLibraryUtils.isValidId)(entryId)) {
    target = `id-${entryId}`;
  } else {
    target = entryId || targetId;
  }
  return /*#__PURE__*/_react.default.createElement(List, {
    "data-active": active,
    role: "menuitem",
    "data-cy": "anchor-link-item"
  }, /*#__PURE__*/_react.default.createElement(_scrollAnchor.default, {
    targetId: target,
    anchorText: anchorText
  }));
}
var _default = exports.default = LinkItem;
LinkItem.propTypes = {
  active: _propTypes.default.bool
};